import { memo } from 'react';
import { DexActivityTabEntry } from '@mark43/cad-api';
import { DexActivityTabVirtuosoEntriesList } from './dex-activity-tab-virtuoso-entries-list';
import { DexNoResults } from './dex-no-results';
import { DexActivityEntry } from './dex-activity-entry';
import { LoadingIndicator } from '../../../common/components/loading-indicator';
import { useEnabledFeatures } from '../../../common/hooks/enabled-features';

export const DexActivityTabBodyContent = memo(function DexActivityTabBodyContent({
    entries,
    isInitialLoading,
}: {
    entries: DexActivityTabEntry[];
    isInitialLoading: boolean;
}) {
    const { rollOutCadEventPanelDexResultsUseVirtuoso } = useEnabledFeatures();

    if (isInitialLoading) {
        return <LoadingIndicator />;
    }

    if (entries.length === 0) {
        return <DexNoResults />;
    }

    if (rollOutCadEventPanelDexResultsUseVirtuoso) {
        return <DexActivityTabVirtuosoEntriesList entries={entries} />;
    }

    return (
        <>
            {entries.map((entry) => {
                return <DexActivityEntry entry={entry} key={entry.elasticUserAction.id} />;
            })}
        </>
    );
});
